export const axisMetadata = {
  left: {
    unit: '%',
  },
};
